import styled from "styled-components";

import Epost from ".././components/Epost";


const ExtraImage = styled.img`
  width: 180px;
  float: left;
  margin: 2px 1rem 0.3rem 0;
`;


const artistInfo = [

  {
    id: 1,
    namn: function () {
      return <>SÄSONGSÖPPNING</>;
    },
    info: function () {
      return (
        <>
          <p>
            Påskafton kl. 11 öppnar krogen dörrarna för säsongen!<br />
            Sedan kommer vi ha öppet lördagar, söndagar och helgdagar kl. 11 - 15.
            <br />Fr.o.m. skolavslutningen 11 juni har vi öppet dagligen; vardagar 11 - 17 och helger 11 - 16.
          </p>
          <p>
            Varmt välkomna till påsk!
          </p>
        </>
      );
    },
    datum: "2026-04-03",
    img: "säsongsöppning",
    pris: 1,
    tid: "11:00",
    konsertmeny: false,
    music: false,
    konst: false,
    author: false,
  },

  {
    id: 2,
    namn: function () {
      return <>MIDSOMMARAFTON</>;
    },
    info: function () {
      return (
        <>
          <p>
            Traditionsenligt så firar vi midsommar på Oxelö Krog med dans och lekar kring midsommarstången till levande musik!<br />

            Midsommarstången kommer att kläs och resas mellan kl 10 - 12.<br />
            Kl. 13 blir det musik och ringlekar!<br />

            <p>Caféet är öppet 10 till 16.
            </p>

            Denna dag har vi en begränsad, speciell midsommarmeny. Menyn kommer publiceras inom kort.
            {/* 
            <ul>
              <li>Midsommartallrik 220 kr - 3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, potatis, smör och bröd.</li>
              <li> Varmrökt lax med färsk potatis och romröra samt smör och bröd</li>
              <li>Räksmörgås</li>
              <li> Pannkakor med grädde och sylt</li>
            </ul>
          */}
            <p>Dessutom har vi förstås fika med bland annat vår fina midsommartårta med jordgubbar</p>


            Varmt välkomna! < br /> <br />
            Glöm inte att ta med folkdräkt om du har en!
          </p >
          <p>OBS! På midsommarafton kommer det inte vara möjligt att parkera på Kroggränd eftersom vi kommer ha dansen där. Vi hänvisar istället till stora parkeringen.</p>
        </>
      );
    },
    datum: "2026-06-19",
    img: "midsommar",
    pris: 0,
    tid: "",
    konsertmeny: false,
    music: true,
  },
  /*
    {
      id: 3,
      namn: function () {
        return <>Eric Bibb</>;
      },
      info: function () {
        return (
          <>
            <p>
              Denna konsert ingår i våra BLUESDAGAR 30 juli - 2 augusti. Under bluesdagarna kommer vi även ha blues dagtid med fri entré för de som gästar caféet. Biljett kan köpas separat till denna konsert men man kan även köpa ett BLUESPASS som ger entré till alla fyra blueskonserter till rabatterat pris.
            </p>
            <p>
              Eric Bibb, född och uppvuxen i New York, är med sina över fyrtio album och mer än femtio år på scenen, en av den internationella bluesvärldens största namn idag och hyllningarna som en av världens främsta akustiska bluesgitarrister är ständigt återkommande.
            </p><p>
              Han har turnerat världen runt i snart trettio år, blivit Grammy-nominerad i USA tre gånger och fått mängder av andra internationella utmärkelser, som t. ex pris för årets akustiska bluesalbum från The Blues Foundation i Memphis 2017 & 2022 och ”Blues Act Of The Year” vid Jazz FM Awards i London 2019. 2022 fick Eric även Stockholms Stads hederspris i musik.
            </p><p>
              Erics far, artisten Leon Bibb, kämpade jämsides med Martin Luther King, Harry Belafonte, Joan Baez och många fler för svartas rättigheter i USA på sextiotalet. Leons framtidsvisioner och mål-medvetenhet tog sig uttryck i musiken och formade Erics konstnärsskap från tidig ålder. Hemma hos familjen Bibb rörde sig en konstant ström av erkända musiker och artister som John Lewis (Erics morbror - pianist/kompositör, grundare av Modern Jazz Quartet), Paul Robeson, Pete Seeger och Josh White. Eric minns särskilt tydligt hur han vid elva års ålder står i pyjamas i vardagsrummet och berättar för Bob Dylan att han minsann också spelar gitarr…
            </p><p>
              Eric har samarbetat med storheter som t.ex Mavis & Pops Staples, Taj Mahal, Odetta, Bonnie Raitt, The Blind Boys of Alabama och The Dixie Hummingbirds. 2019 spelade han för utsålda hus i en vecka på legendariska Ronnie Scott’s i London, då även Van Morrison var Eric’s gäst en av kvällarna.
            </p><p>
              2017 turnerade han Sverige runt med den hyllade enmans-föreställningen ”Tales From A Blues Brother”, som också sändes i Sveriges Television. Den producerades av hans son Rennie Mirro och Filip Adamo och kan nu ses på Qwest TV. Ni har också kunnat se honom i På Spåret, SVT och Bingolotto, TV4, där han sjöng en duett med Sarah Dawn Finer. Sommaren 2022 såg ni honom i SVT:s Allsång På Skansen!
            </p><p>
              2021 släppte han plattan ”Dear America” med gäster som bl. a Ron Carter, Eric Gales och Steve Jordan. 2023 släpptes hans opus Ridin’, den liksom Dear America producerades av Glen Scott, nu med gäster som Taj Mahal och Russell Malone.
            </p><p>
              I september 2022 kunde du se honom på Scalateaterns scen Stockholm tillsammans med ett spännande band och gästerna Sarah Dawn Finer och Rennie Mirro. Konserten spelades in och filmades inför ett live-album, som släpptes i april 2024. Hösten 2023 medverkade han i föreställningen ’Ögonblicket’ på Västmanlands Teater och är just nu aktuell i rollen som den demente musikern John i filmen ’Så Länge Hjärtat Slår’, som kan ses på TV4 Play.
            </p>
            <p>
  
            </p>
          </>
        );
      },
      datum: "2026-06-27",
      img: "Eric-Bibb",
      pris: 280,
      tid: "18:00",
      konsertmeny: true,
      music: true,
      foto: "Michael Wall",
      slutsålt: false,
      youtube: "https://youtu.be/HYhwUgl3P0U?si=Rcf3quZItAXlTj_i",
      youtubenamn: "Family",
      youtube2: "https://youtu.be/j__moFFnAJg?si=ek6RKqQSL1YU0HyU",
      youtubenamn2: "500 miles",
      biljett_id: 0,
    },
  
    {
      id: 4,
      namn: function () {
        return <>Malena Ernman och Mats Bergström</>;
      },
      info: function () {
        return (
          <>
            <p>
              Malena Ernman bjuder tillsammans med musikerkollegan Mats Bergström på efterlängtade musikpärlor med allt från Mozart till visor jazz och musikal.
            </p><p>
              Malena Ernman är en av Sveriges mest mångsidiga och folkkära artister – en prisbelönt operasångerska med en röst som trollbinder oavsett genre. Hon har erövrat Europas största scener, tävlat i Eurovision och berört publik med både klassisk elegans för sin unika röst, sin sceniska närvaro och sin genreöverskridande musikalitet.
            </p><p>
              Mats Bergström är en av Sveriges främsta gitarrister, med en imponerande bredd inom klassisk musik, jazz, visa och samtida konstmusik. Han är en mångsidig musiker och eftertraktad ackompanjatör som har arbetat med några av landets största artister och tonsättare. Med sin känslighet, precision och kreativa uttryck är han en musikalisk berättare av högsta rang.
            </p><p>
              Tillsammans bildar Malena Ernman och Mats Bergström en enastående duo. Deras samspel präglas av närhet, lyhördhet och en kärlek till musiken som smittar av sig på publiken. I deras gemensamma konserter möts sång och gitarr i ett uttrycksfullt och intimt musikaliskt samtal, där gränser suddas ut mellan genrer, epoker och språk.
            </p>
          </>
        )
      },
      datum: "2026-07-04",
      img: "malena_mats",
      foto: "",
      pris: 280,
      tid: "18:00",
      konsertmeny: true,
      music: true,
      youtube: "https://www.youtube.com/watch?v=fa8PN-CazkY",
      youtubenamn: "Gabriellas sång",
      youtube2: "https://www.youtube.com/watch?v=oWkSagVP1uQ",
      youtubenamn2: "Youll never walk alone",
      biljett_id: 0,
  
    },
  */
  {
    id: 5,
    namn: function () {
      return <>Janne Schaffer</>;
    },
    info: function () {
      return (
        <>
          <p>
            Janne Schaffer - My Music Story
          </p><p>
            Varmt välkommen på en fantastisk konsert med Janne Schaffer och pianisten och sångaren Jonas Gideon!  Konserten bjuder på en resa som spänner över i stort sett hela den moderna svenska musikhistorien. Det är en hisnande färd från 60-talets popband, via ABBA och Ted Gärdestad till Björn J:son Lindh och Electric Banana Band med extra fokus på Ted Gärdestad.
          </p><p>
            Janne Schaffer har varit en del av den svenska musikscenen i över 50 år. Han har medverkat på närmare 5000 låtar, gett ut 27 egna skivor samt gjort tio album med Electric Banana Band. Han har spelat med ABBA, Ted Gärdestad, Bob Marley och Toto, gett ut fjorton soloalbum, blivit samplad av Christina Aguilera och nådde förra året topp­placeringar på brittiska klubblistan tillsammans med elektroduon ManyFew. Just nu är han aktuell med filmmusiken till långfilmen Biodlaren med Adam Lundgren, som får biopremiär i år. Hans låt Happy Feet är också med i Jonatan Etzlers biofilm Bad Apples med Saoirse Ronan, som hade världspremiär på Toronto Film Festival.
          </p><p>
            - Jag är så tacksam att jag fortfarande kan vara aktiv både som solist, låtskrivare och studiomusiker och jag lovar att bjuda på massor av musik tillsammans med både fina och roliga minnen, säger Janne Schaffer.
          </p>
        </>
      );
    },
    datum: "2026-07-11",
    img: "schaffer",
    foto: "Annie Hyrefeldt",
    pris: 300,
    tid: "18:00",
    konsertmeny: true,
    music: true,
    youtube: "https://www.youtube.com/watch?v=QUUGxe-ar9s&t=16s",
    youtubenamn: "Halkans shop live",
    youtube2: "https://www.youtube.com/watch?v=uIvFglCUuuI",
    youtubenamn2: "Brusa högre lilla å",
    biljett_id: 79441,
  },
  /*
    {
        id: 6,
        namn: function () {
          return <></>;
        },
        info: function () {
          return (
            <>
              <p>
              </p><p>
              </p><p>
              </p><p>
              </p>
            </>
          );
        },
        datum: "2026-07-18",
        img: "",
        foto: "",
        pris: 250,
        tid: "18:00",
        konsertmeny: true,
        music: true,
        youtube: "",
        youtubenamn: "",
        youtube2: "",
        youtubenamn2: "",
        biljett_id: 0,
      },
    
      {
        id: 7,
        namn: function () {
          return <></>;
        },
        info: function () {
          return (
            <>
              <p>
              </p><p>
              </p><p>
              </p><p>
              </p>
            </>
          );
        },
        datum: "2026-08-01",
        img: "",
        foto: "",
        pris: 250,
        tid: "18:00",
        konsertmeny: true,
        music: true,
        youtube: "",
        youtubenamn: "",
        youtube2: "",
        youtubenamn2: "",
        biljett_id: 0,
      },
    
      {
        id: 8,
        namn: function () {
          return <></>;
        },
        info: function () {
          return (
            <>
              <p>
              </p><p>
              </p><p>
              </p><p>
              </p>
            </>
          );
        },
        datum: "2026-08-08",
        img: "",
        foto: "",
        pris: 250,
        tid: "18:00",
        konsertmeny: true,
        music: true,
        youtube: "",
        youtubenamn: "",
        youtube2: "",
        youtubenamn2: "",
        biljett_id: 0,
      },
  */
  {
    id: 9,
    namn: function () {
      return <>BELLMANDAGEN</>;
    },
    info: function () {
      return (
        <>
          <p>
            Vår traditionella Bellmandag blir i år på en söndag. Som vanligt
            kommer krogbacken att befolkas av 1700-talsklädda individer och vi
            klär även upp vår personal!
          </p>
          <p>
            Thord Lindé kommer att underhålla såsom Fredman tillsammans med sina musiker samt även gästframträdanden.
          </p>
          <p>
            Bellman-quiz för stora och små utlovas med fina Bellman-priser!
          </p>
          <p>
            De som kommer 1700-talsklädda bjuder vi på något att äta. Så ta fram din gamla 1700-talsdräkt ur garderoben!
          </p>

          {/* 
            <p>
              Hålltider:<br />
              <ul>
                <li>kl. 12 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 13 Folk- och vistrion ro.t.</li>
                <li>kl. 14 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 14:40 Vinnarna i årets Quiz koras.</li>
              </ul>
            </p>          
          */}

          <p>Varmt välkomna!</p>
        </>
      );
    },
    datum: "2026-07-27",
    img: "bellmandagen",
    pris: 0,
    tid: "HELA DAGEN",
    konsertmeny: false,
    music: true,
    youtube: "https://www.youtube.com/watch?v=t1ggVXHyvNw",
    youtubenamn: "SOLEN GLIMMAR",

  },
];

export default artistInfo;